module.exports = __webpack_public_path__ + "img/quick_nav4.0d889ecf.png";